import { z } from 'zod';

export const presentationTypeValues = ['SW', 'SCL', 'SCS', 'SC25', 'SP'] as const;
export type PresentationType = (typeof presentationTypeValues)[number];
export const PresentationTypeSchema: z.ZodType<PresentationType> = z.enum(presentationTypeValues);

export const shipmentScaleTypeValues = ['INTERNAL', 'PROCESSOR'] as const;
export type ShipmentScaleType = (typeof shipmentScaleTypeValues)[number];
export const ShipmentScaleTypeSchema: z.ZodType<ShipmentScaleType> =
  z.enum(shipmentScaleTypeValues);

export const shipmentMaterialRefTypeValues = ['SHIPMENT_MATERIAL', 'LOAD_SESSION_GROUP'] as const;
export type ShipmentMaterialRefType = (typeof shipmentMaterialRefTypeValues)[number];
export const ShipmentMaterialRefTypeSchema: z.ZodType<ShipmentMaterialRefType> = z.enum(
  shipmentMaterialRefTypeValues,
);

export const shipmentLogisticsCaptureShellStatusValues = [
  'ACTIVE',
  'LINKED',
  'REVERSED',
  'ARCHIVED',
] as const;
export type ShipmentLogisticsCaptureShellStatus =
  (typeof shipmentLogisticsCaptureShellStatusValues)[number];
export const ShipmentLogisticsCaptureShellStatusSchema: z.ZodType<ShipmentLogisticsCaptureShellStatus> =
  z.enum(shipmentLogisticsCaptureShellStatusValues);

export const shipmentWeighScaleRoleValues = ['PUBLIC', 'PROCESSOR', 'INTERNAL', 'OTHER'] as const;
export type ShipmentWeighScaleRole = (typeof shipmentWeighScaleRoleValues)[number];
export const ShipmentWeighScaleRoleSchema: z.ZodType<ShipmentWeighScaleRole> = z.enum(
  shipmentWeighScaleRoleValues,
);
export const secureShipmentWeighScaleRoleValues = ['PUBLIC', 'PROCESSOR', 'OTHER'] as const;
export type SecureShipmentWeighScaleRole = (typeof secureShipmentWeighScaleRoleValues)[number];
export const SecureShipmentWeighScaleRoleSchema: z.ZodType<SecureShipmentWeighScaleRole> = z.enum(
  secureShipmentWeighScaleRoleValues,
);

export const shipmentWeighTypeValues = ['GROSS', 'TARE', 'NET_DIRECT', 'MANUAL_PAIR'] as const;
export type ShipmentWeighType = (typeof shipmentWeighTypeValues)[number];
export const ShipmentWeighTypeSchema: z.ZodType<ShipmentWeighType> =
  z.enum(shipmentWeighTypeValues);

export const shipmentWeighEntryStatusValues = ['pending', 'submitted', 'complete'] as const;
export type ShipmentWeighEntryStatus = (typeof shipmentWeighEntryStatusValues)[number];
export const ShipmentWeighEntryStatusSchema: z.ZodType<ShipmentWeighEntryStatus> = z.enum(
  shipmentWeighEntryStatusValues,
);

export const shipmentWeighNetFeedbackStatusValues = [
  'awaiting_net_weight',
  'possible_net',
  'net_ready',
] as const;
export type ShipmentWeighNetFeedbackStatus = (typeof shipmentWeighNetFeedbackStatusValues)[number];
export const ShipmentWeighNetFeedbackStatusSchema: z.ZodType<ShipmentWeighNetFeedbackStatus> =
  z.enum(shipmentWeighNetFeedbackStatusValues);

export const shipmentWeighCaptureSourceValues = [
  'ADMIN',
  'OPERATOR_QUICK_CAPTURE',
  'EMPLOYEE_DRIVER',
  'SECURE_LINK',
  'SYSTEM_IMPORT',
] as const;
export type ShipmentWeighCaptureSource = (typeof shipmentWeighCaptureSourceValues)[number];
export const ShipmentWeighCaptureSourceSchema: z.ZodType<ShipmentWeighCaptureSource> = z.enum(
  shipmentWeighCaptureSourceValues,
);

export const shipmentQuickCaptureTargetKindValues = [
  'FULL_SHIPMENT',
  'LOGISTICS_SHELL',
  'COVER_SHIPMENT',
] as const;
export type ShipmentQuickCaptureTargetKind = (typeof shipmentQuickCaptureTargetKindValues)[number];
export const ShipmentQuickCaptureTargetKindSchema: z.ZodType<ShipmentQuickCaptureTargetKind> =
  z.enum(shipmentQuickCaptureTargetKindValues);

export const shipmentQuickCaptureCapturePhaseValues = [
  'pre_departure',
  'departed_logistics',
] as const;
export type ShipmentQuickCaptureCapturePhase =
  (typeof shipmentQuickCaptureCapturePhaseValues)[number];
export const ShipmentQuickCaptureCapturePhaseSchema: z.ZodType<ShipmentQuickCaptureCapturePhase> =
  z.enum(shipmentQuickCaptureCapturePhaseValues);

export const shipmentQuickCaptureMaterialTaskStatusValues = [
  'needs_correction',
  'needs_capture',
  'needs_second_weight',
  'captured',
  'unavailable',
] as const;
export type ShipmentQuickCaptureMaterialTaskStatus =
  (typeof shipmentQuickCaptureMaterialTaskStatusValues)[number];
export const ShipmentQuickCaptureMaterialTaskStatusSchema: z.ZodType<ShipmentQuickCaptureMaterialTaskStatus> =
  z.enum(shipmentQuickCaptureMaterialTaskStatusValues);

export const shipmentQuickCaptureCannotSubmitReasonValues = [
  'already_captured',
  'target_unavailable',
  'material_unavailable',
  'locked',
  'not_current',
  'expired_link',
  'processed',
] as const;
export type ShipmentQuickCaptureCannotSubmitReason =
  (typeof shipmentQuickCaptureCannotSubmitReasonValues)[number];
export const ShipmentQuickCaptureCannotSubmitReasonSchema: z.ZodType<ShipmentQuickCaptureCannotSubmitReason> =
  z.enum(shipmentQuickCaptureCannotSubmitReasonValues);

export const shipmentQuickCaptureReadinessStatusValues = [
  'not_started',
  'missing_capture',
  'needs_correction',
  'all_assigned_materials_captured',
] as const;
export type ShipmentQuickCaptureReadinessStatus =
  (typeof shipmentQuickCaptureReadinessStatusValues)[number];
export const ShipmentQuickCaptureReadinessStatusSchema: z.ZodType<ShipmentQuickCaptureReadinessStatus> =
  z.enum(shipmentQuickCaptureReadinessStatusValues);

export const shipmentWeighReviewStatusValues = [
  'SUBMITTED',
  'VERIFIED',
  'CORRECTED',
  'VOIDED',
] as const;
export type ShipmentWeighReviewStatus = (typeof shipmentWeighReviewStatusValues)[number];
export const ShipmentWeighReviewStatusSchema: z.ZodType<ShipmentWeighReviewStatus> = z.enum(
  shipmentWeighReviewStatusValues,
);

export const shipmentDriverAssignmentStatusValues = ['ACTIVE', 'REMOVED'] as const;
export type ShipmentDriverAssignmentStatus = (typeof shipmentDriverAssignmentStatusValues)[number];
export const ShipmentDriverAssignmentStatusSchema: z.ZodType<ShipmentDriverAssignmentStatus> =
  z.enum(shipmentDriverAssignmentStatusValues);

export const shipmentWeighInventoryComparisonStatusValues = [
  'no_hu_reference',
  'awaiting_net_weight',
  'matches_hu_expected',
  'below_hu_expected',
  'above_hu_expected',
] as const;
export type ShipmentWeighInventoryComparisonStatus =
  (typeof shipmentWeighInventoryComparisonStatusValues)[number];
export const ShipmentWeighInventoryComparisonStatusSchema: z.ZodType<ShipmentWeighInventoryComparisonStatus> =
  z.enum(shipmentWeighInventoryComparisonStatusValues);

export const shipmentWeighPaymentThresholdStatusValues = [
  'no_reportable_weight',
  'awaiting_net_weight',
  'passes_threshold',
  'below_threshold',
] as const;
export type ShipmentWeighPaymentThresholdStatus =
  (typeof shipmentWeighPaymentThresholdStatusValues)[number];
export const ShipmentWeighPaymentThresholdStatusSchema: z.ZodType<ShipmentWeighPaymentThresholdStatus> =
  z.enum(shipmentWeighPaymentThresholdStatusValues);

export const shipmentWeighNetCandidateSourceValues = [
  'DERIVED_GROSS_TARE',
  'LINKED_GROSS_TARE',
  'MANUAL_PAIR',
  'NET_DIRECT',
] as const;
export type ShipmentWeighNetCandidateSource =
  (typeof shipmentWeighNetCandidateSourceValues)[number];
export const ShipmentWeighNetCandidateSourceSchema: z.ZodType<ShipmentWeighNetCandidateSource> =
  z.enum(shipmentWeighNetCandidateSourceValues);

export const shipmentWeighOperationalCardSourceValues = [
  'DERIVED_GROSS_TARE',
  'LINKED_GROSS_TARE',
  'MANUAL_PAIR',
  'NET_DIRECT',
  'PAIR_SUGGESTION',
  'GROSS_ONLY',
  'TARE_ONLY',
] as const;
export type ShipmentWeighOperationalCardSource =
  (typeof shipmentWeighOperationalCardSourceValues)[number];
export const ShipmentWeighOperationalCardSourceSchema: z.ZodType<ShipmentWeighOperationalCardSource> =
  z.enum(shipmentWeighOperationalCardSourceValues);

export const rcScopeTypeValues = ['store', 'location'] as const;
export type RcScopeType = (typeof rcScopeTypeValues)[number];
export const RcScopeTypeSchema: z.ZodType<RcScopeType> = z.enum(rcScopeTypeValues);

export const shipmentTargetWarningCodeValues = [
  'INSUFFICIENT_TOTAL_WEIGHT',
  'MISSING_SW_RATE',
] as const;
export type ShipmentTargetWarningCode = (typeof shipmentTargetWarningCodeValues)[number];
export const ShipmentTargetWarningCodeSchema: z.ZodType<ShipmentTargetWarningCode> = z.enum(
  shipmentTargetWarningCodeValues,
);

export const shipmentTargetOperationalStatusValues = [
  'WITHIN_OPERATIONAL_LOSS',
  'OVER_OPERATIONAL_LOSS',
] as const;
export type ShipmentTargetOperationalStatus =
  (typeof shipmentTargetOperationalStatusValues)[number];
export const ShipmentTargetOperationalStatusSchema: z.ZodType<ShipmentTargetOperationalStatus> =
  z.enum(shipmentTargetOperationalStatusValues);

export const shipmentTargetOfficialProxyStatusValues = [
  'WITHIN_2_5_PROXY',
  'EXCEEDS_2_5_PROXY',
] as const;
export type ShipmentTargetOfficialProxyStatus =
  (typeof shipmentTargetOfficialProxyStatusValues)[number];
export const ShipmentTargetOfficialProxyStatusSchema: z.ZodType<ShipmentTargetOfficialProxyStatus> =
  z.enum(shipmentTargetOfficialProxyStatusValues);

export const shipmentTargetScenarioLevelValues = ['normal', 'warning', 'danger'] as const;
export type ShipmentTargetScenarioLevel = (typeof shipmentTargetScenarioLevelValues)[number];
export const ShipmentTargetScenarioLevelSchema: z.ZodType<ShipmentTargetScenarioLevel> = z.enum(
  shipmentTargetScenarioLevelValues,
);

export const OFFICIAL_PROXY_TOLERANCE_PCT = 2.5;

export const shipmentBuilderModeValues = ['range', 'target'] as const;
export type ShipmentBuilderMode = (typeof shipmentBuilderModeValues)[number];
export const ShipmentBuilderModeSchema: z.ZodType<ShipmentBuilderMode> =
  z.enum(shipmentBuilderModeValues);

export const shipmentTargetScenarioValues = ['under', 'over'] as const;
export type ShipmentTargetScenario = (typeof shipmentTargetScenarioValues)[number];
export const ShipmentTargetScenarioSchema: z.ZodType<ShipmentTargetScenario> = z.enum(
  shipmentTargetScenarioValues,
);

export const shipmentStatusValues = ['DRAFT', 'ACTIVE', 'VOIDED'] as const;
export type ShipmentStatus = (typeof shipmentStatusValues)[number];
export const ShipmentStatusSchema: z.ZodType<ShipmentStatus> = z.enum(shipmentStatusValues);

export const shipmentAuditActionValues = [
  'CREATE_DRAFT',
  'UPDATE_DRAFT',
  'SAVE',
  'VOID',
  'SCALE_TICKET_ADD',
  'SCALE_TICKET_UPDATE',
  'SCALE_TICKET_VOID',
  'WEIGH_EVENT_ADD',
  'WEIGH_EVENT_LINK',
  'WEIGH_EVENT_UNLINK',
  'WEIGH_EVENT_VERIFY',
  'WEIGH_EVENT_CORRECT',
  'WEIGH_EVENT_VOID',
  'DRIVER_ASSIGNMENT_ADD',
  'DRIVER_ASSIGNMENT_REMOVE',
  'WEIGH_CAPTURE_LINK_CREATE',
  'WEIGH_CAPTURE_LINK_REVOKE',
] as const;
export type ShipmentAuditAction = (typeof shipmentAuditActionValues)[number];
export const ShipmentAuditActionSchema: z.ZodType<ShipmentAuditAction> =
  z.enum(shipmentAuditActionValues);

export const IsoDateSchema = z.iso.date();
export const IsoDateTimeSchema = z.string().trim().pipe(z.iso.datetime());
